import React, { useContext } from 'react'
import { Arrow, Check, Divider, scrollTo } from 'chemistry'
import select from '../selectors/attributes'
import { TranslateContext } from 'client/common/translator'
import { dictionary } from '../../../common/accessability'

const ProductUsp = ({ usps, lang }) => {
  const t = useContext(TranslateContext)
  if (!usps) return null
  const specs = '#specs'

  return (
    <div>
      <ul className='list-none p0' aria-label={dictionary(lang).usp}>
        {select(usps).map(it => (
          <li key={it} className='flex items-center gap-half'>
            <Check />
            {it}
          </li>
        ))}
      </ul>
      <Divider mt='md' mb='3xs' />
      <a
        className='flex gap-1 items-center my2'
        href={specs}
        onClick={() => scrollTo(specs, 700, ['.mxd-header', '.mxd-header-beta'])}
      >
        <Arrow />
        {t('spec')}
      </a>
    </div>
  )
}

export default ProductUsp
